import { parseHtml } from '../core/utils';
import { observer } from 'mobx-react-lite';
import { useLandingPageContent } from '../hooks/useLandingPageContent';

export const HTMLContent = observer(() => {
  let htmlContent = useLandingPageContent();

  if (!htmlContent) return null;

  return (
    <div className="rounded-b-md bg-brand-1 shadow">
      <div className="html-content text-white px-10 pt-3 pb-5">
        {parseHtml(htmlContent)}
      </div>
    </div>
  );
});
